import React from "react"
import { AppBulkEditAction } from "@components"

import { useAcrissGroups, useAcrissGroupsValidator } from "Pages/OneWay/AcrissGroups/@hooks"


export default function AcrissGroupDrawerSubmit() {
	const { isLoading, handleSubmitFormData } = useAcrissGroups()
	const { isValid } = useAcrissGroupsValidator()

	return <AppBulkEditAction
		loading={isLoading}
		disabled={!isValid}
		onClick={handleSubmitFormData}
	>
		Save
	</AppBulkEditAction>
}
